import script from "./ScheduleVistoria.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleVistoria.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleVistoria.vue?vue&type=style&index=0&id=9f058dae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f058dae"]])

export default __exports__